import React, { useEffect, useState } from 'react'
import Navbar from '../nav/Navbar';
import Footer from '../footer/Footer'

function Grievance_redressal_mechanism() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Detect dark mode preference
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
        // Check if user prefers dark mode
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        setIsDarkMode(mediaQuery.matches);

        // Listen for changes
        const handleChange = (e) => setIsDarkMode(e.matches);
        mediaQuery.addEventListener('change', handleChange);

        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    const styles = {
        container: {
            fontFamily: 'Arial, sans-serif',
            lineHeight: '1.6',
            color: isDarkMode ? '#e0e0e0' : '#333',
            maxWidth: '800px',
            margin: '0 auto',
            padding: '20px',
            backgroundColor: isDarkMode ? '#1a1a1a' : 'transparent',
            minHeight: '100vh'
        },
        header: {
            textAlign: 'center',
            color: isDarkMode ? '#ffffff' : '#2c3e50',
            marginBottom: '30px',
            borderBottom: `2px solid ${isDarkMode ? '#4a90e2' : '#3498db'}`,
            paddingBottom: '10px'
        },
        underline: {
            textDecoration: 'underline'
        },
        section: {
            backgroundColor: isDarkMode ? '#2d2d2d' : '#f8f9fa',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '25px',
            borderLeft: `4px solid ${isDarkMode ? '#4a90e2' : '#3498db'}`,
            color: isDarkMode ? '#e0e0e0' : '#333'
        },
        stepContainer: {
            marginBottom: '30px'
        },
        stepHeader: {
            marginBottom: '15px',
            fontSize: '18px',
            fontWeight: 'bold',
            color: isDarkMode ? '#ffffff' : '#2c3e50'
        },
        contactBox: {
            backgroundColor: isDarkMode ? '#3d3d3d' : '#ecf0f1',
            padding: '15px',
            borderRadius: '6px',
            margin: '10px 0',
            color: isDarkMode ? '#e0e0e0' : '#333',
            border: isDarkMode ? '1px solid #555' : 'none'
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            margin: '20px 0',
            fontSize: '14px',
            backgroundColor: isDarkMode ? '#2d2d2d' : 'transparent'
        },
        tableHeader: {
            backgroundColor: isDarkMode ? '#3d3d3d' : '#34495e',
            color: isDarkMode ? '#ffffff' : 'white',
            padding: '12px',
            textAlign: 'left',
            border: `1px solid ${isDarkMode ? '#555' : '#ddd'}`
        },
        tableCell: {
            padding: '12px',
            border: `1px solid ${isDarkMode ? '#555' : '#ddd'}`,
            verticalAlign: 'top',
            backgroundColor: isDarkMode ? '#2d2d2d' : '#f9f9f9',
            color: isDarkMode ? '#e0e0e0' : '#333'
        },
        tableRow: {
            backgroundColor: isDarkMode ? '#2d2d2d' : '#f9f9f9'
        },
        link: {
            color: isDarkMode ? '#4a90e2' : '#2980b9',
            textDecoration: 'none'
        },
        linkHover: {
            color: isDarkMode ? '#6ab0f3' : '#1a5276',
            textDecoration: 'underline'
        },
        footer: {
            textAlign: 'center',
            marginTop: '40px',
            padding: '20px',
            backgroundColor: isDarkMode ? '#2d2d2d' : '#2c3e50',
            color: isDarkMode ? '#e0e0e0' : 'white',
            borderRadius: '8px',
            border: isDarkMode ? '1px solid #444' : 'none'
        },
        highlight: {
            backgroundColor: isDarkMode ? '#3d3d3d' : '#fff3cd',
            padding: '10px',
            borderRadius: '4px',
            border: `1px solid ${isDarkMode ? '#555' : '#ffeaa7'}`,
            margin: '10px 0',
            color: isDarkMode ? '#e0e0e0' : '#333'
        },
        strong: {
            color: isDarkMode ? '#ffffff' : 'inherit',
            fontWeight: 'bold'
        }
    };

    return (
        <div style={{ backgroundColor: isDarkMode ? '#1a1a1a' : 'transparent', minHeight: '100vh' }}>
            <Navbar />
            <div style={styles.container}>
                <div style={styles.header}>
                    <h1 style={styles.underline}>Grievance Redressal Mechanism</h1>
                </div>

                <div style={styles.section}>
                    <p>
                        At Kaabil Finance Private Limited, we believe in providing the best of services to our customers.
                        We provide customers with easy access to information, products and services, as well as the means
                        to get their grievances redressed. This can include behavioural aspects, inadequate functions or
                        services rendered by the Company or any of the outsourced vendors associated with the company.
                    </p>
                </div>

                {/* Step 1 */}
                <div style={styles.stepContainer}>
                    <div style={styles.stepHeader}>Step 1</div>
                    <div style={styles.section}>
                        <p>
                            Please visit the nearest branch of Kaabil Finance Private Limited and submit your
                            complaint/grievance to the branch official. Kindly get your complaint lodged in branch/HO
                            and the Centralized Customer Complaint Register maintained at the HO (During the working
                            hours i.e., from 10:00 A.M to 6:00 P.M.)
                        </p>

                        <div style={styles.highlight}>
                            <p>
                                Alternatively, you can reach our customer service team at <strong style={styles.strong}>1800 571 3088</strong> or
                                email us at <a href="mailto:care@kaabilfinance.com" style={styles.link}>care@kaabilfinance.com</a>.
                                We will respond to your complaint within 15 days.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Step 2 */}
                <div style={styles.stepContainer}>
                    <div style={styles.stepHeader}>Step 2</div>
                    <div style={styles.section}>
                        <p>
                            If the Customer is not satisfied with the provided solution, the same complaint can be
                            escalated to the Grievance Redressal Officer / Principal Nodal Officer.
                        </p>
                        <p>
                            After examining the matter, The Grievance Redressal Officer/Principal Nodal Officer will
                            take necessary steps to redress the grievance with due care and diligence. They shall
                            respond to the complaint within 15 days or explain the reason, in case it needs more
                            time to respond.
                        </p>

                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.tableHeader}>Name</th>
                                    <th style={styles.tableHeader}>Designation</th>
                                    <th style={styles.tableHeader}>Address</th>
                                    <th style={styles.tableHeader}>E-mail</th>
                                    <th style={styles.tableHeader}>Contact</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={styles.tableRow}>
                                    <td style={styles.tableCell}>Mr. Puneet Bhandari</td>
                                    <td style={styles.tableCell}>Grievance Redressal Officer</td>
                                    <td style={styles.tableCell}>
                                        Plot No 1 Scheme No 1, Income Tax Colony Model Town, Jagatpura, Jaipur, Rajasthan, India, 302017
                                    </td>
                                    <td style={styles.tableCell}>
                                        <a 
                                            href="mailto:Grievanceredressal@kaabilfinance.com" 
                                            style={styles.link}
                                            onMouseOver={(e) => e.target.style.color = styles.linkHover.color}
                                            onMouseOut={(e) => e.target.style.color = styles.link.color}
                                        >
                                            Grievanceredressal@kaabilfinance.com
                                        </a>
                                    </td>
                                    <td style={styles.tableCell}><strong style={styles.strong}>1800 571 3088</strong></td>
                                </tr>
                                <tr>
                                    <td style={styles.tableCell}>Mr. Harshal Chandak</td>
                                    <td style={styles.tableCell}>Principal Nodal Officer</td>
                                    <td style={styles.tableCell}>
                                        Plot No 1 Scheme No 1, Income Tax Colony Model Town, Jagatpura, Jaipur, Rajasthan, India, 302017
                                    </td>
                                    <td style={styles.tableCell}>
                                        <a 
                                            href="mailto:pno@kaabilfinance.com" 
                                            style={styles.link}
                                            onMouseOver={(e) => e.target.style.color = styles.linkHover.color}
                                            onMouseOut={(e) => e.target.style.color = styles.link.color}
                                        >
                                            pno@kaabilfinance.com
                                        </a>
                                    </td>
                                    <td style={styles.tableCell}><strong style={styles.strong}>1800 571 3088</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Step 3 */}
                <div style={styles.stepContainer}>
                    <div style={styles.stepHeader}>Step 3</div>
                    <div style={styles.section}>
                        <p>
                            If the resolution of complaint is delayed beyond 30 days of receipt or the Customer is not
                            satisfied with the resolution provided or reason of delay conveyed to them, then they may
                            file a complaint with RBI Ombudsman through the complaint lodging portal of the Ombudsman at
                            <a 
                                href="https://cms.rbi.org.in" 
                                style={styles.link}
                                onMouseOver={(e) => e.target.style.color = styles.linkHover.color}
                                onMouseOut={(e) => e.target.style.color = styles.link.color}
                            > https://cms.rbi.org.in</a> or through
                            the e-mail or physical mode at the following address:
                        </p>

                        <div style={styles.contactBox}>
                            <p><strong style={styles.strong}>Centralised Receipt and Processing Centre</strong></p>
                            <p>Reserve Bank of India, 4th Floor, Sector 17, Chandigarh - 160017</p>
                            <p><strong style={styles.strong}>Toll Free No.:</strong> 14448 (9:30 am to 5:15 pm)</p>
                            <p>
                                <strong style={styles.strong}>E-mail:</strong>{' '}
                                <a 
                                    href="mailto:CRPC@rbi.org.in" 
                                    style={styles.link}
                                    onMouseOver={(e) => e.target.style.color = styles.linkHover.color}
                                    onMouseOut={(e) => e.target.style.color = styles.link.color}
                                >CRPC@rbi.org.in</a>
                            </p>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div style={styles.footer}>
                    <p><strong style={styles.strong}>KAABIL FINANCE PRIVATE LIMITED</strong></p>
                    <p>CIN: U65929RJ2017PTC058138</p>
                    <p>
                        <strong style={styles.strong}>Reg. Office:</strong> Plot No 1 Scheme No 1, Income Tax Colony Model Town,
                        Jagatpura, Jaipur, Rajasthan, India, 302017
                    </p>
                    <p>
                        <strong style={styles.strong}>Tel. No.:</strong> 1800 571 3088{' '}
                        <strong style={styles.strong}>Website:</strong>{' '}
                        <a 
                            href="http://www.Kaabilfinance.com" 
                            style={{...styles.link, color: isDarkMode ? '#e0e0e0' : '#ecf0f1'}}
                            onMouseOver={(e) => e.target.style.color = isDarkMode ? '#ffffff' : '#ffffff'}
                            onMouseOut={(e) => e.target.style.color = isDarkMode ? '#e0e0e0' : '#ecf0f1'}
                        >
                            www.Kaabilfinance.com
                        </a>{' '}
                        <strong style={styles.strong}>Email Id:</strong>{' '}
                        <a 
                            href="mailto:care@kaabilfinance.com" 
                            style={{...styles.link, color: isDarkMode ? '#e0e0e0' : '#ecf0f1'}}
                            onMouseOver={(e) => e.target.style.color = isDarkMode ? '#ffffff' : '#ffffff'}
                            onMouseOut={(e) => e.target.style.color = isDarkMode ? '#e0e0e0' : '#ecf0f1'}
                        >
                            care@kaabilfinance.com
                        </a>
                    </p>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Grievance_redressal_mechanism